export const BARCODE_MAX_LENGTH = 64;

/** Trim and strip control characters (CR/LF/Tab/…) that scanners append. */
export function cleanBarcode(raw: unknown): string {
  // eslint-disable-next-line no-control-regex
  return String(raw ?? '').replace(/[\u0000-\u001f\u007f]/g, '').trim();
}

/** Printable ASCII only, 1–64 characters. */
export function isValidBarcode(code: string): boolean {
  return code.length > 0 && code.length <= BARCODE_MAX_LENGTH && /^[\x20-\x7e]+$/.test(code);
}
